(function () {
  'use strict';

  angular
    .module('greatCircleDistance')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('greatCircleDistance', {
        url: '/great-circle-distance',
        views: {
          'greatCircleDistanceView': {
            templateUrl: 'great-circle-distance/views/great-circle-distance.tpl.html',
            controller: 'GreatCircleDistanceCtrl',
            controllerAs: 'greatCircleDistance'
          }
        }
      });
  }
}());
